import React, { useState } from 'react';
import { useWindowSize } from 'react-use';
import { screenIsSmall } from 'utils/screen-is-small';
import { Card, Link, Text } from '@perch-labs/shrike';
import { NotificationKey } from 'domain/notifications';
import { Container } from 'styles';
import Markdown from 'markdown-to-jsx';
import store from 'store';
import { StyledContainer } from '../notifications/notification-card/notification-card.style';
import { NotificationSVG } from '../notifications/notification-svg';
import { StyledIconButton, StyledText } from './lmi-baner.style';

export const LMIBanner = () => {
  const [hide, setHide] = useState<boolean>(!!store.get('hideLMI'));
  const hideBanner = () => {
    setHide(true);
    store.set('hideLMI', true);
  };

  const displayValues = {
    title: 'Do you qualify as a low-to-moderate income household?',
    message:
      'If you receive financial assistance for your household costs or benefits from a government program, you might qualify for quicker access to savings on your energy costs.',
    buttonText: 'Check eligibility',
  };
  const { title, message, buttonText } = displayValues;
  const { width } = useWindowSize();
  const messageProps = !screenIsSmall(width)
    ? {
        margin: { top: '16px' },
      }
    : undefined;
  const CHECK_LMI_ELIGIBILITY = '/settings/check-lmi-eligibility';
  const linkTo = { pathname: CHECK_LMI_ELIGIBILITY };

  if (hide) {
    return null;
  }

  return (
    <Card mobileVariant="flat" data-testid="notification-card">
      <StyledContainer
        flex
        padding="24px"
        small={{ direction: 'column', padding: '24px' }}
      >
        <NotificationSVG notificationKey={NotificationKey.lowIncomeHousehold} />
        <>
          <Container>
            <StyledText tag="h3" textStyle="heading500">
              {title}
            </StyledText>
            <Text margin={{ top: '8px' }} {...messageProps}>
              <Markdown
                options={{
                  overrides: {
                    a: {
                      component: Link,
                      props: {
                        openInNewTab: false,
                        type: 'inline',
                      },
                    },
                  },
                }}
              >
                {message}
              </Markdown>
            </Text>
            <Link
              aria-label="check-eligibility"
              size="small"
              type="CTA"
              color="primary"
              backgroundless={true}
              to={linkTo}
              style={{ marginTop: '16px' }}
            >
              {buttonText}
            </Link>
          </Container>
          <StyledIconButton
            aria-label="dismiss"
            icon="UIClose"
            onClick={() => hideBanner()}
          />
        </>
      </StyledContainer>
    </Card>
  );
};
